import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import Toturial from './Toturial';
import { ModalDefaultDraggable } from '../../../../../../molecules';
import { setShowTutorial } from '../../../../../../redux/slices/generalSlice';
import userSettings from '../../../../../../api/userSettings';
import { RootState } from '../../../../../../redux/root';

const TutorialPopup = () => {
  const dispatch = useDispatch();
  const info = useSelector((s: RootState) => s.userAuth.info);

  const onClose = async () => {
    const userId = info.id;
    const data: any = { loginBefore: true };
    await userSettings.sendNewUserData(userId, data);
    dispatch(setShowTutorial(false));
  };

  return (
    <ModalDefaultDraggable
      narrow
      centered
      title="Quick Tutorial"
      onClose={onClose}
    >
      <Subtitle>Pick a short walkthrough to get started.</Subtitle>
      <Toturial />
      <Footer>
        To see this list again, click <HELP>HELP</HELP> on the left navigation.
      </Footer>
    </ModalDefaultDraggable>
  );
};

export default TutorialPopup;

const Subtitle = styled.div`
  text-align: center;
  font-size: 0.875rem;
  color: var(--neutral-500);
  margin: -10px 0 22px;
`;

const Footer = styled.div`
  margin-top: 24px;
  padding: 12px 14px;
  text-align: center;
  font-size: 0.8125rem;
  color: var(--neutral-600);
  background: var(--neutral-50);
  border: 1px solid var(--border);
  border-radius: 8px;
`;

const HELP = styled.span`
  font-weight: 700;
  font-style: italic;
  color: var(--primary-700);
  letter-spacing: 0.02em;
`;
